import { User } from "../models/User";

export class Workflow {
  Id: number | null;
  Tenant: number;
  ProcessName: string;
  Active: boolean;
  StatusCode: string;
  ProcessXML: string;
  ProcessId: string;
  CreatedDate: Date;
  CreatedByUserId: number | null;
  UpdatedDate: Date;
  UpdatedByUserId: number | null;
  CreatedByUser: User;
  UpdatedByUser: User;
}